module.exports = __webpack_public_path__ + "img/big_11B21_orange.7348ee86.png";